/**
 * Handle Accordion
 */


const requestOptions = {
  method: 'GET',
  redirect: 'follow'
};

function fnBrowserDetect(){
    let userAgent = navigator.userAgent;
    let browserName;

    if(userAgent.match(/edg/i)){
      browserName = "Edge";
      $('.btn--fixed-wrapper').addClass('hidden');
      $('.hero__actions-desktop').removeClass('hidden');
    }else if(userAgent.match(/chrome|chromium|crios/i)){
      browserName = "Chrome";
      $('.btn--fixed-wrapper').addClass('hidden');
      $('.hero__actions-desktop').removeClass('hidden');
    }else if(userAgent.match(/firefox|fxios/i)){
      browserName = "Firefox";
      $('.btn--fixed-wrapper').addClass('hidden');
      $('.hero__actions-desktop').removeClass('hidden');
    }  else if(userAgent.match(/safari/i)){
      browserName = "Safari";
      $('.btn--fixed-wrapper').addClass('hidden');
      $('.hero__actions-desktop').removeClass('hidden');
    }else if(userAgent.match(/opr\//i)){
      browserName = "Opera";
      $('.btn--fixed-wrapper').addClass('hidden');
      $('.hero__actions-desktop').removeClass('hidden');
    }else{
      browserName="No browser detection";
    }

    return browserName;
}

function deviceDetect(){
    let userAgent = navigator.userAgent;
    let deviceName;

    if(userAgent.includes("Android")){
      deviceName = "android";
      $('.btn--fixed-wrapper').removeClass('hidden');
      $('.hero__actions-desktop').addClass('hidden');
    }else if(userAgent.includes("iPhone")){
      deviceName = "ios";
      $('.btn--fixed-wrapper').removeClass('hidden');
      $('.hero__actions-desktop').addClass('hidden');
    }else{
      deviceName="No browser detection";
    }

    return deviceName;
}

let extensionSection = () => {
    let $hero = $(".hero .hero__actions-desktop");

    fetch("https://production.getpriceapp.com/api/cashback/store/list/?retailers=" + $('.js-shop').data('shop') + "&source=search", requestOptions)
        .then(response => response.json())
        .then(result => {
            let browserName = fnBrowserDetect();
            let btnLink;

            if(browserName == "Chrome"){
                  btnLink = "https://chrome.google.com/webstore/detail/pricecom-best-pricescashb/kmmpkhpajpecmpdmmbpjmkmcmfdahkcj/related?hl=en"
            } else if(browserName == "Firefox"){
                  btnLink = "https://addons.mozilla.org/en-US/firefox/addon/price-com-best-prices/"
            } else if(browserName == "Safari"){
                  btnLink = "https://apps.apple.com/us/app/price-com/id1424535163?mt=12"
            } else if(browserName == "Edge"){
                  btnLink = "https://microsoftedge.microsoft.com/addons/detail/pricecombest-pricescas/dgckpmehjdlnekhncppncegogekpaake"
            } else{
                  btnLink="#";
            }

            let sectionMarkup = `
                <a href="${btnLink}" class="orange-button size-1" target="_blank">Add to <span>${browserName}<span> – It’s Free</a>
            `
            let headerbtn = document.querySelector('.header__btn');
            headerbtn ? headerbtn.innerHTML = `Add to <span>${browserName}<span> – It’s Free` : "";

            $hero.append(sectionMarkup)
        })
        .catch(error => console.log('error', error));
}

let extensionSectionMobile = () => {
    let $hero = $(".btn--fixed-wrapper");


    fetch("https://production.getpriceapp.com/api/cashback/store/list/?retailers=" + $('.js-shop').data('shop') + "&source=search", requestOptions)
        .then(response => response.json())
        .then(result => {
            let deviceName = deviceDetect();
            let btnLink = "https://price.com/download";
           
            let sectionMarkup = `
                <a href="${btnLink}" class="orange-button size-1" target="_blank"><span>Get Started<span></a>
            `

            $hero.append(sectionMarkup)
        })
        .catch(error => console.log('error', error));
}

fnBrowserDetect();
deviceDetect();
extensionSection();

$(window).on('load', function(){
  extensionSectionMobile();
})
